import { getDefaultSetting } from '@/api/businessSetting'
import store from '@/store'

const businessSetting = {
  state: {
    tax: 0,
    // 0 折扣不参与税计算 1 折扣参与税计算
    taxType: 1,
    // 存储所有配置项的对象
    allSettings: {},
    // 营业设置
    opsSettings: {},
    // 显示设置
    layoutSettings: {}
  },
  mutations: {
    // 设置所有配置项
    SET_ALL_SETTINGS: (state, settings) => {
      state.allSettings = settings
    },
    // 设置营业设置
    SET_OPS_SETTINGS: (state, settings) => {
      settings.forEach(item => {
        state.opsSettings[item.display_key] = item.display_value
      })
    },
    // 设置显示设置
    SET_LAYOUT_SETTINGS: (state, settings) => {
      settings.forEach(item => {
        state.layoutSettings[item.display_key] = item.display_value
      })
    }
  },
  actions: {
    // 初始化营业设置
    initBusinessSetting ({ commit, state }) {
      return new Promise((resolve, reject) => {
        // 定义默认配置
        const getDefaultSettings = [
          { ID: 28, HostName: null, SettingGroup: 3, SettingDesc: '税率', SettingKey: 'main_taxrate', SettingValue: '8.75', ValueType: 0, CreateTime: '2018-10-15T16:00:00.000Z', L1: 'Tax', L2: '税率' },
          { ID: 29, HostName: null, SettingGroup: 3, SettingDesc: '税率2', SettingKey: 'main_taxrate2', SettingValue: '10', ValueType: 0, CreateTime: '2018-10-15T16:00:00.000Z', L1: 'Tax 2', L2: '税率2' },
          { ID: 31, HostName: null, SettingGroup: 3, SettingDesc: '总计Adjust', SettingKey: 'main_total_adjust', SettingValue: '0', ValueType: 5, CreateTime: '2018-10-15T16:00:00.000Z', L1: 'Adjust', L2: '总计Adjust', typelist: [{ TypeID: 21, ValueType: 5, ValueTypeDesc: '实际金额', SettingValue: '0', CreateTime: '2018-06-14T16:00:00.000Z', L1: 'Actual Amount', L2: '实际金额' }, { TypeID: 22, ValueType: 5, ValueTypeDesc: '三进五，八进十', SettingValue: '1', CreateTime: '2018-06-14T16:00:00.000Z', L1: '3to5,8to10', L2: '三进五，八进十' }, { TypeID: 23, ValueType: 5, ValueTypeDesc: '向上取整，进五或十', SettingValue: '2', CreateTime: '2018-06-14T16:00:00.000Z', L1: 'Up, to 5,10', L2: '向上取整，进五或十' }, { TypeID: 24, ValueType: 5, ValueTypeDesc: '向上取整，进十', SettingValue: '3', CreateTime: '2018-06-14T16:00:00.000Z', L1: 'Up, to 10', L2: '向上取整，进十' }, { TypeID: 25, ValueType: 5, ValueTypeDesc: '四舍五入', SettingValue: '4', CreateTime: '2018-06-14T16:00:00.000Z', L1: 'Rounding', L2: '四舍五入' }] },
          { ID: 40, HostName: null, SettingGroup: 3, SettingDesc: '休息时间', SettingKey: 'rest_middle_time', SettingValue: '15:00', ValueType: 0, CreateTime: '2018-10-15T16:00:00.000Z', L1: 'Rest Time', L2: '休息时间' },
          { ID: 41, HostName: null, SettingGroup: 3, SettingDesc: '营业时间', SettingKey: 'rest_end_time', SettingValue: '7:30', ValueType: 0, CreateTime: '2018-10-15T16:00:00.000Z', L1: 'Bus. Time', L2: '营业时间' },
          { ID: 109, HostName: null, SettingGroup: 3, SettingDesc: '号码前三位', SettingKey: 'main_phone3', SettingValue: '', ValueType: 8888, CreateTime: '2018-10-15T16:00:00.000Z', L1: 'Area Code', L2: '号码前三位' }
        ]

        // 使用Promise.all等待两个请求都完成
        Promise.all([
          getDefaultSetting({ storeid: store.getters.storeid, type: 1 })
            .catch(error => {
              console.error('Failed to load business settings, using default settings:', error)
              // 返回默认配置
              return { Rounding: getDefaultSettings }
            })
          // getDefaultSetting({storeid: store.getters.storeid, type: 3})
          // .catch(error => {
          //   console.error('Failed to load layout settings, using default settings:', error)
          //   // 返回默认配置
          //   return { Rounding: getDefaultSettings }
          // })
        ])
          .then(([businessRes]) => {
          // 处理业务设置
            const businessData = businessRes.Rounding && businessRes.Rounding.length ? businessRes.Rounding : getDefaultSettings
            commit('SET_OPS_SETTINGS', businessData)

            // 处理布局设置
            // const layoutData = layoutRes.Rounding && layoutRes.Rounding.length ? layoutRes.Rounding : getDefaultSettings

            // 查找ThemeColor配置
            // const themeColorSetting = layoutData.find(item => item.display_key === 'ThemeColor')
            // if (themeColorSetting && themeColorSetting.display_value) {
            // 如果存在ThemeColor配置，调用settings.js的CHANGE_SETTING mutation更新主题颜色
            // store.commit('settings/CHANGE_SETTING', {
            //   key: 'theme',
            //   value: themeColorSetting.display_value
            // })
            // }

            // commit('SET_LAYOUT_SETTINGS', layoutData)

            // 合并所有配置项
            commit('SET_ALL_SETTINGS', {
              opsSettings: state.opsSettings
            // 'layoutSettings': state.layoutSettings
            })
            console.log('allSettings', state.allSettings)
            // 只有在两个请求都完成后才resolve
            resolve(state.allSettings)
          })
          .catch(error => {
            console.error('allSettings 初始化异常:', error)
            reject(error)
          })
      })
    }

  },
  getters: {
    // 获取所有配置项
    businessSettings: state => state.settings,
    // 获取营业配置
    opsSettings: state => state.opsSettings,
    // 获取布局设置
    // layoutSettings: state => state.layoutSettings,
    // 获取税率（兼容旧版本）
    tax: state => {
      return state.opsSettings.tax ? state.opsSettings.tax : 0
    },
    // 获取税率类型（兼容旧版本）
    taxType: state => {
      // 假设从API获取的数据中有taxType的配置项
      return state.opsSettings.tinyint ? state.opsSettings.Taxdeduction : 1
    },
    // 舍入模式
    Rounding: state => {
      return state.opsSettings.Rounding ? state.opsSettings.Rounding : 0
    },
    // 营业时间
    OpeningTime: state => {
      return state.opsSettings.OpeningTime ? state.opsSettings.OpeningTime : '12:00 AM'
    },
    // 休息时间
    ClosingTime: state => {
      return state.opsSettings.ClosingTime ? state.opsSettings.ClosingTime : '12:00 PM'
    },
    // 根据SettingKey获取OpsSettings配置项
    getOpsSettingByKey: state => (key, defaultValue = null) => {
      if (state.opsSettings[key]) {
        return state.opsSettings[key]
      }
      return defaultValue
    }
  }
}

export default businessSetting
